<template>
  <div class="agent-interview-stat-table">
    <div class="table-header">
      <div class="col-agent">{{ $t('job.dialog.openToAgent.tableHeaders.agent') }}</div>
      <div class="col-stat">{{ $t('job.dialog.openToAgent.tableHeaders.resumeScreening') }}</div>
      <div class="col-stat">{{ $t('job.dialog.openToAgent.tableHeaders.interview') }}</div>
    </div>
    <div class="table-body">
      <div v-for="item in agentStats" :key="item.headhuntingId" class="table-row">
        <div class="col-agent">
          <span class="agent-name" v-hover-tip.over="item.headhuntingName">{{ item.headhuntingName }}</span>
        </div>
        <div class="col-stat" @click="resumeClick(item, item.resumeScreeningCount > 0)" :class="{ highlight: item.resumeScreeningCount > 0 }">
          {{ item.resumeScreeningCount }}
        </div>
        <div class="col-stat" @click="interviewClick(item, item.interviewCount > 0)" :class="{ highlight: item.interviewCount > 0 }">
          {{ item.interviewCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter, type Router } from 'vue-router';
import {
  SelectionListTab
} from '@/enum/interview';
import { RouteNames } from '@/router/config/route-names';
export interface AgentInterviewStat {
  headhuntingId: number;
  headhuntingName: string;
  resumeScreeningCount: number;
  interviewCount: number;
}

interface Props {
  agentStats: AgentInterviewStat[];
}
const emit = defineEmits<{
    resumeClick: [AgentInterviewStat],
    interviewClick: [AgentInterviewStat],
}>()
const props = withDefaults(defineProps<Props>(), {});
const resumeClick = (item: AgentInterviewStat, canClick: boolean) => {
  if (!canClick) return;
  emit('resumeClick', item);
}
const interviewClick = (item: AgentInterviewStat, canClick: boolean) => {
  if (!canClick) return;
  emit('interviewClick', item);
}
</script>

<style scoped>
.agent-interview-stat-table {
  overflow: hidden;
  width: 100%;
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: 253px 92px 92px;
  height: 40px;
  line-height: 40px;
}

.table-header {
  background: #f7f8fa;
  color: #6B7075;
  font-size: 14px;
  font-weight: 500;
}

.table-row:last-child {
  border-bottom: none;
}

.col-agent {
  display: flex;
  align-items: center;
  min-width: 0;
  padding-left: 12px;
}

.agent-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-stat {
  padding-left: 12px;
  font-size: 14px;
}

.col-stat.highlight {
  color: var(--el-color-primary);
  font-weight: 500;
  cursor: pointer;
}
</style>
